import validate from "/home/runner/work/octo/octo/node_modules/.pnpm/nuxt@3.9.0_@types+node@18.19.4_eslint@8.52.0_rollup@2.79.1_typescript@5.2.2_vite@5.0.10_vue-tsc@1.8.21/node_modules/nuxt/dist/pages/runtime/validate.js";
import analytics_45global from "/home/runner/work/octo/octo/middleware/analytics.global.ts";
import redirects_45global from "/home/runner/work/octo/octo/middleware/redirects.global.ts";
import manifest_45route_45rule from "/home/runner/work/octo/octo/node_modules/.pnpm/nuxt@3.9.0_@types+node@18.19.4_eslint@8.52.0_rollup@2.79.1_typescript@5.2.2_vite@5.0.10_vue-tsc@1.8.21/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  analytics_45global,
  redirects_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}